import QRCode from "qrcode";

/** Renders a signup URL as a QR PNG data URL, tinted to the page palette so
 * it reads as part of the page rather than a pasted-in widget. */
export function generateSignupQrDataUrl(url: string): Promise<string> {
  return QRCode.toDataURL(url, {
    errorCorrectionLevel: "M",
    margin: 1,
    width: 240,
    color: {
      dark: "#201C17",
      light: "#FAF9F600",
    },
  });
}
